import { UserRole } from "../enums/role.enum";

export class SidebarItem {
  label: string = '';
  route: string = '';
  roles: UserRole[] = [];
  icon: any;
  image?: string;
  section: string = '';
  children?: SidebarItem[];

  constructor(data: any = {}) {
    this.map(data);
  }

  private map(data: any): void {
    Object.keys(this).forEach((key) => {
      if (data[key] !== undefined) {
        (this as any)[key] = data[key];
      }
    });
  }
}
